<template>
  <v-dialog v-model="dialog" max-width="500px" @keydown.esc="close()">
    <v-card>
      <v-card-title>
        <span class="headline" style="margin-left: 20px; margin-top: 5px"
          >Modifica qtà in magazzino</span
        >
      </v-card-title>
      <v-card-text>
        <v-container grid-list-xl>
          <v-col>
            <v-flex>
              <v-text-field
                label="Cod.Articolo"
                v-model="editedItem.COD_ART"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                label="Cod.Articolo Vostro"
                v-model="editedItem.COD_ART_MAG_FOR"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                label="Descrizione"
                v-model="editedItem.DESC_ART"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-row>
                <v-flex>
                  <v-text-field
                    label="Q.tà"
                    v-model="editedItem.QTA_MAG_FOR"
                    style="width: 100px"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    label="Q.tà prossima produzione"
                    v-model="editedItem.QTA_PREVISIONE"
                    style="width: 220px"
                  ></v-text-field>
                </v-flex>
              </v-row>
            </v-flex>
          </v-col>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.native="close">Annulla</v-btn>
        <v-btn color="blue darken-1" text @click.native="save">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    editedItem: null,
    dialog: { type: Boolean, default: false },
  },

  methods: {
    save() {
      this.$emit("save");
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
